import { createSlice } from "@reduxjs/toolkit";
import {
  getPreguntasConfirmacionThunk,
  getPreguntaConfirmacionByIdThunk,
  updatePreguntaConfirmacionThunk,
  togglePreguntaConfirmacionActiveThunk,
} from "./preguntasConfirmacion.thunks";

const initialState = {
  list: [],
  loading: false,
  error: null,
  page: 1,
  pageSize: 10,
  totalPages: 1,
  count: 0,
  next: null,
  previous: null,
  maxPageReached: 1,
  search: "",

  selectedPregunta: null,
  selectedPreguntaLoading: false,
  selectedPreguntaError: null,
  viewModalOpen: false,

  formModalOpen: false,
  formMode: "edit", // solo "edit" - NO se permite crear
  formLoading: false,
  formError: null,

  confirmModalOpen: false,
  togglePreguntaId: null,
  toggling: false,
};

const preguntasConfirmacionSlice = createSlice({
  name: "preguntasConfirmacion",
  initialState,
  reducers: {
    clearPreguntasConfirmacionError: (state) => {
      state.error = null;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSearch: (state, action) => {
      state.search = action.payload;
      state.page = 1;
    },
    openViewModal: (state) => {
      state.viewModalOpen = true;
    },
    closeViewModal: (state) => {
      state.viewModalOpen = false;
      state.selectedPregunta = null;
    },
    openFormModal: (state, action) => {
      state.formModalOpen = true;
      state.formMode = "edit"; // siempre edición
      if (action.payload?.pregunta) {
        state.selectedPregunta = action.payload.pregunta;
      }
      state.formError = null;
    },
    closeFormModal: (state) => {
      state.formModalOpen = false;
      state.selectedPregunta = null;
      state.formError = null;
    },
    openConfirmToggle: (state, action) => {
      state.confirmModalOpen = true;
      state.togglePreguntaId = action.payload.id;
    },
    closeConfirmToggle: (state) => {
      state.confirmModalOpen = false;
      state.togglePreguntaId = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // GET ALL
      .addCase(getPreguntasConfirmacionThunk.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getPreguntasConfirmacionThunk.fulfilled, (state, action) => {
        const { results, count, next, previous } = action.payload;

        state.loading = false;
        state.list = results;
        state.count = count;
        state.next = next;
        state.previous = previous;

        state.maxPageReached = Math.max(state.maxPageReached, state.page);
      })
      .addCase(getPreguntasConfirmacionThunk.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // GET BY ID
      .addCase(getPreguntaConfirmacionByIdThunk.pending, (state) => {
        state.selectedPreguntaLoading = true;
        state.selectedPreguntaError = null;
      })
      .addCase(getPreguntaConfirmacionByIdThunk.fulfilled, (state, action) => {
        state.selectedPreguntaLoading = false;
        state.selectedPregunta = action.payload;
      })
      .addCase(getPreguntaConfirmacionByIdThunk.rejected, (state, action) => {
        state.selectedPreguntaLoading = false;
        state.selectedPreguntaError = action.payload;
      })

      // UPDATE
      .addCase(updatePreguntaConfirmacionThunk.pending, (state) => {
        state.formLoading = true;
        state.formError = null;
      })
      .addCase(updatePreguntaConfirmacionThunk.fulfilled, (state, action) => {
        state.formLoading = false;
        const index = state.list.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
        state.formModalOpen = false;
      })
      .addCase(updatePreguntaConfirmacionThunk.rejected, (state, action) => {
        state.formLoading = false;
        state.formError = action.payload;
      })

      // TOGGLE ACTIVE
      .addCase(togglePreguntaConfirmacionActiveThunk.pending, (state) => {
        state.toggling = true;
      })
      .addCase(togglePreguntaConfirmacionActiveThunk.fulfilled, (state, action) => {
        state.toggling = false;
        state.confirmModalOpen = false;
        const index = state.list.findIndex((p) => p.id === action.payload.id);
        if (index !== -1) {
          state.list[index] = action.payload;
        }
      })
      .addCase(togglePreguntaConfirmacionActiveThunk.rejected, (state, action) => {
        state.toggling = false;
        state.error = action.payload;
      });
  },
});

export const {
  clearPreguntasConfirmacionError,
  setPage,
  setSearch,
  openViewModal,
  closeViewModal,
  openFormModal,
  closeFormModal,
  openConfirmToggle,
  closeConfirmToggle,
} = preguntasConfirmacionSlice.actions;

export default preguntasConfirmacionSlice.reducer;
